module.exports = __webpack_public_path__ + "img/EnviarIcon.bc11bb50.svg";